import { Component, Input } from '@angular/core';
import { PaymentProvider } from '../../providers/payment/payment';
import { PaymentMethodType } from '../../model/types/payment-method-type';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'rmt-payment-account',
  templateUrl: 'rmt-payment-account.html'
})
export class RmtPaymentAccountComponent {
  @Input() account;
  @Input() isSelected = false;
  @Input() selectorEnabled = true;
  @Input() isSelectable = false;
  @Input() labels;  

  constructor(private paymentProvider: PaymentProvider,
              private translate: TranslateService
  ) {    
  }

  getPaymentAccountTitle(account) {
    return (account.accountType + ' •••• ' + account.maskedAccountNumber.replace(/\*/g, ''));
  }

  getPaymentSubTitle(account) {
    if (account.paymentMethod === PaymentMethodType.DebitCard)
      return this.translate.instant('page.paymentAccountDetailsPage.paymentMethods.debitCard');
    return this.translate.instant('page.paymentAccountDetailsPage.paymentMethods.creditCard');
  }

  getPaymentDescription(account) {
    if (account.disabled)
      return this.translate.instant('page.paymentAccountListPage.ria_errormessage_2103');
    return '';
  }

  getPaymentAccountCss(account) {
    let css = '';
    if (!this.selectorEnabled)
      css += ' item-disabled';

    if (account.disabled)
      css += ' account-disabled';
    else if (account.isExpired)
      css += ' account-expired';
    return css;
  }

  getCardIconNew(card) {
    if (card.isExpired)
      return this.paymentProvider.getCardIcon(card);
    else
      return this.paymentProvider.getCardIcon(card, true);
  }
}



// WEBPACK FOOTER //
// ./src/components/rmt-payment-account/rmt-payment-account.ts